<style scoped>
  .fast-slide-enter-active, .fast-slide-leave-active {
    transition: all 0.7s;
  }

  .fast-slide-enter, .fast-slide-leave-to {
    opacity: 0.8;
    transform: translateY(100%);
  }

  .fast-slide-leave-to {
    transition: all 0s;
  }

  div.placeholder {
    width: 100%;
    height: 0;
    background: #f7f7f7;
    position: relative;
  }

  img.placeholded-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .pu_bottom_inner {
    /*min-height: auto;*/
    max-height: 60px;
    background: none;
  }

  .pu_bottom_inner.filled {
    /*min-height: 100vh;*/
    max-height: 100vh;
    background: #fff;
  }

  .pu_bottom_inner::before {
    display: none;
    background: none;
  }

  .pu_bottom.auto {
    height: auto;
  }

</style>
<template>
  <transition name="bottomslide">
    <div v-show="$store.getters.modal.search" class="pu_bottom" style="z-index: 1000" :class="{'auto':!input}">
      <div class="pu_bottom_scroll">
        <vue100vh :css="{height: '100rvh'}" class="pu_bottom_inner scroll_y"
                  :class="{'filled':input && input === $store.getters.search.query}">
          <div class="hl_search_form" style="position: relative">
            <button></button>
            <input type="text" class="hide-placeholder" v-model="input"
                   :placeholder="text('search_placeholder')"
                   :ref="'search-input'">
            <div class="hl_search_clear" @click="clear()"></div>
          </div>

          <ul class="tovar_list plr" style="padding-left: 20px; padding-right: 20px;"
              v-if="$store.getters.modal.searchFull && input && input === $store.getters.search.query && $store.getters.loading.fetchSearch && !$store.getters.search.gotFirst">
            <li v-for="index in 6" :key="index"><a class="tl_block">
              <div class="tl_img">
                <div class="placeholder shine" style="display: block; padding-top: 230px;">
                  <div class="tl_price" style="width: 40px"></div>
                </div>
              </div>
              <div class="tl_name shine"
                   style="border-radius: 4px; width: 80px; height: 16px; display: block"></div>
            </a></li>
          </ul>

          <template
            v-if="$store.getters.modal.searchFull && input && input === $store.getters.search.query && $store.getters.search.gotFirst">
            <div class="hl_search_info plr">
              <template
                v-if="input && !$store.getters.loading.fetchSearch && (!$store.getters.search.categories.length && !$store.getters.search.products.meta.total)">
                {{ text('search_empty') }}
              </template>
              <template v-if="$store.getters.search.categories.length && !$store.getters.search.products.meta.total">
                {{ text('search_found_categories', { categories: $store.getters.search.categories.length }) }}
              </template>
              <template v-if="!$store.getters.search.categories.length && $store.getters.search.products.meta.total">
                {{ text('search_found_products', { products: $store.getters.search.products.meta.total }) }}
              </template>
              <template v-if="$store.getters.search.categories.length && $store.getters.search.products.meta.total">
                {{
                text('search_found_categories_and_products', {
                products: $store.getters.search.products.meta.total,
                categories: $store.getters.search.categories.length
                })
                }}
              </template>
            </div>

            <div class="search_content plr" v-if="$store.getters.search.categories.length">
              <div class="popular_head">
                <div class="ti">{{ text('categories') }}</div>
              </div>
              <CategoryList :categories="$store.getters.search.categories" :search="true"/>
            </div>
            <div class="search_tovar plr" v-if="$store.getters.search.products.meta.total">
              <div class="popular_head">
                <div class="ti">{{ text('products') }}</div>
              </div>
              <ProductList :products="$store.getters.search.products.items" :mode="MODE_SEARCH"/>
            </div>
          </template>


        </vue100vh>


      </div>
    </div>
  </transition>
</template>

<script>
  import {CLEAR_SEARCH, SET_MODAL, SET_SEARCH_GOT_FIRST, SET_SEARCH_QUERY} from '@/store/mutations.type'
  import {FETCH_SEARCH} from '@/store/actions.type'
  import CategoryList from '@/components/ECommerce/Categories/CategoryList'
  import ProductList from '@/components/ECommerce/Products/ProductList'
  import {mapGetters} from 'vuex'

  const MODE_CATEGORY = 0
  const MODE_POPULAR = 1
  const MODE_SEARCH = 2

  import vue100vh from 'vue-100vh'

  let debounce = require('lodash.debounce')

  export default {
    name: 'SearchModal',
    components: {ProductList, CategoryList, vue100vh},
    data() {
      return {
        input: '',

        MODE_CATEGORY, MODE_POPULAR, MODE_SEARCH
      }
    },
    computed: {
      loadedCategories() {
        let ids = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].id) {
            ids.push(this.$store.getters.categories[i].id)
          }
        }
        return ids
      },
      ...mapGetters(['modal'])
    },
    watch: {
      modal: {
        deep: true,
        handler: function (modal, old) {
          if (modal.search) {
            this.enable()
          }
        }
      },
      input: async function () {
        await this.$store.commit(CLEAR_SEARCH)
        await this.$store.commit(SET_SEARCH_QUERY, this.input)

        debounce(async () => {
          await this.search()
        }, 500)()
      }
    },
    methods: {

      clear() {
        if (!this.input.length) {
          this.$store.commit(SET_MODAL, {modal: 'search', status: false})
        }
        this.input = ''
      },

      enable() {
        if (this.input) {
          this.$store.commit(SET_MODAL, {modal: 'searchFull', status: true})
        }
        let input = this.$refs['search-input']
        if (input !== document.activeElement) {
          document.activeElement.blur()
          setTimeout(function () {
            input.focus()
          }, 0)
        }
      },

      async search() {
        this.items = []

        if (!this.input.length) {
          this.$store.commit(SET_MODAL, {modal: 'searchFull', status: false})
          // document.body.classList.remove('overflow')

          await this.$store.commit(CLEAR_SEARCH)
          return
        }


        this.$store.commit(SET_MODAL, {modal: 'searchFull', status: true})
        // document.body.classList.add('overflow')

        await this.$store.dispatch(FETCH_SEARCH, {
          categories: this.loadedCategories,
          query: this.input
        })

      }

    }
  }
</script>

<style scoped>

  div.placeholder {
    width: 100%;
    height: 0;
    position: relative;
    border-radius: 16px;
  }
</style>
